/**
 * 客服 API 服务（auth-starter 版）
 */

import { apiService } from './api';

const API_BASE = '/support';

export interface SupportConversation {
  id: string;
  user_id: string;
  last_message_at: string | null;
  sms_notified_at: string | null;
  created_at: string;
  updated_at: string;
}

export type SupportSenderRole = 'user' | 'agent';
export type SupportContentType = 'text' | 'image';

export interface SupportMessage {
  id: string;
  conversation_id: string;
  sender_role: SupportSenderRole;
  content_type: SupportContentType;
  content: string | null;
  image_url: string | null;
  delivered: boolean;
  created_at: string;
}

/** 把后端返回的相对图片路径拼成完整 URL */
export function buildStaticUrl(pathOrUrl: string): string {
  if (!pathOrUrl) return '';
  if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) return pathOrUrl;
  const base = (import.meta.env.VITE_STATIC_BASE_URL as string) || window.location.origin;
  const normalized = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return `${base}${normalized}`;
}

export const supportApi = {
  /** 打开或创建客服会话（单会话） */
  async openConversation(): Promise<{ conversation: SupportConversation }> {
    const res: any = await apiService.post(`${API_BASE}/conversations`);
    return res.data;
  },

  /** 获取当前用户会话（无则 null） */
  async getActiveConversation(): Promise<SupportConversation | null> {
    const res: any = await apiService.get(`${API_BASE}/conversations/active`);
    return res.data?.conversation || null;
  },

  /** 当前用户客服未读数 */
  async getUnread(): Promise<number> {
    const res: any = await apiService.get(`${API_BASE}/unread`);
    return res.data?.unread || 0;
  },

  /** 标记当前用户客服会话已读 */
  async markRead(): Promise<void> {
    await apiService.post(`${API_BASE}/read`);
  },

  /** 获取会话历史消息 */
  async getMessages(conversationId: string, before?: string, limit = 50): Promise<SupportMessage[]> {
    const params = new URLSearchParams();
    if (before) params.set('before', before);
    params.set('limit', String(limit));
    const res: any = await apiService.get(
      `${API_BASE}/conversations/${conversationId}/messages?${params.toString()}`
    );
    return res.data?.messages || [];
  },

  /** 上传聊天图片，返回图片引用 URL */
  async uploadImage(file: File): Promise<string> {
    const formData = new FormData();
    formData.append('image', file);
    // 直接用 axios 实例带 multipart，绕过 apiService 的 JSON 头
    const token = localStorage.getItem('accessToken') || '';
    const base = (import.meta.env.VITE_API_BASE_URL as string) || '/api';
    const resp = await fetch(`${base}${API_BASE}/upload/image`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
    });
    const json = await resp.json();
    return json?.data?.imageUrl;
  },
};
